module.exports = __webpack_public_path__ + "media/images/new_home/map-pin-a09e0a4fd63330ab8f6a4a48700c3a60.png";